import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3674ad7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-section-h3 d-flex justify-center mb-3"
}
const _hoisted_2 = {
  key: 0,
  class: "content-div"
}
const _hoisted_3 = { class: "section-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: "section",
    style: _normalizeStyle(!_ctx.isContentVisible ? {height: '337px !important'} : '')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["background", _ctx.isBackground()]),
      style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.imageUrl + ')' })
    }, null, 6),
    _createElementVNode("div", {
      class: _normalizeClass(["main-content d-flex", _ctx.isBlack ? 'content-black' : 'content-white'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isContentVisible ? 'main-section-isContent' : 'main-section')
      }, [
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.isContentVisible ? 'main-section-h2-isContent' : 'main-section-h2')
        }, _toDisplayString(_ctx.heading), 3),
        (!_ctx.isContentVisible)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.subheading), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          class: _normalizeClass(_ctx.learnMoreBtnStyle()),
          onClick: _ctx.showContent,
          elevation: "0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isContentVisible ? 'See Less' : 'Learn More'), 1)
          ]),
          _: 1
        }, 8, ["class", "onClick"])
      ], 2),
      (_ctx.isContentVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.content), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 4))
}